import { createActions } from 'redux-actions'


export const {
  refreshAuthState,
} = createActions(
  'REFRESH_AUTH_STATE',
)